<template>
	<div class="grid col-12 px-4">
		<div class="col-12"> <h1 class="second-level-heading">Manage Users</h1> </div>
		<slot name="searchForm"></slot>
		<div class="col-12">
			<slot></slot>
		</div>
	</div>
</template>